import { tokenFetchPOST } from '../lib/tokenUtils';
import { logChatBotMessage } from '../lib/analyticsEvents';
import { serverApi } from '../lib/utils';
// API_KEY = "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"

let prevMessages = [];
export const sendChatQuestion = async (
    question,
) => {
    // final Map res = {
    //   "id": "cmpl-uqkvlQyYK7bGYrRHQ0eXlWi7",
    //   "object": "text_completion",
    //   "created": 1589478378,
    //   "model": "text-davinci-003",
    //   "choices": [
    //     {
    //       "text":
    //           // "\n\nThis is indeed a test <a href='Conan O’Brien Needs A Friend'>goog</a> ",
    //           "\n\nThis is indeed a test <a href='Conan'>goog</a> ",
    //       "index": 0,
    //       "logprobs": null,
    //       "finish_reason": "length"
    //     }
    //   ],
    //   "usage": {"prompt_tokens": 5, "completion_tokens": 7, "total_tokens": 12}
    // };
    logChatBotMessage(question);
    const postBody = {
        'contextMessages': prevMessages,
        'userPrompt': question
    };
    logChatBotMessage(question);
    return tokenFetchPOST(
        // 'http://localhost:5001/podcastapp-767c2/us-central1/getChatResponse?t=1',
        `${serverApi}getChatResponse?t=1`,
        JSON.stringify(postBody))
        .then(async (dataInit) => {
            // utils.printLog('tokenFetchPOST data');
            const data = await dataInit.json();
            console.dir(data);
            const ans = data['content'];
            if (ans != null) {
                const origAns = data['origAns'];
                if (prevMessages.length >= 2) {
                    prevMessages.shift();
                    console.dir(prevMessages);
                }
                prevMessages.push(origAns);
                return ans; //{'success': true};
            } else {
                return 'Currently chat is down';
            }
        }).catch((err) => {
            console.dir(err);
            return 'No response';
        });
    // return res['choices'] != null && res['choices'].length > 0
    //     ? res['choices'][0]['text']
    //     : 'No response';
}

export const sendChatQuestionDashboard = async (
    question,
) => {
    // final Map res = {
    //   "id": "cmpl-uqkvlQyYK7bGYrRHQ0eXlWi7",
    //   "object": "text_completion",
    //   "created": 1589478378,
    //   "model": "text-davinci-003",
    //   "choices": [
    //     {
    //       "text":
    //           // "\n\nThis is indeed a test <a href='Conan O’Brien Needs A Friend'>goog</a> ",
    //           "\n\nThis is indeed a test <a href='Conan'>goog</a> ",
    //       "index": 0,
    //       "logprobs": null,
    //       "finish_reason": "length"
    //     }
    //   ],
    //   "usage": {"prompt_tokens": 5, "completion_tokens": 7, "total_tokens": 12}
    // };
    logChatBotMessage(question);
    const postBody = {
        'contextMessages': prevMessages,
        'userPrompt': question
    };
    logChatBotMessage(question);
    return tokenFetchPOST(
        // 'http://localhost:5001/podcastapp-767c2/us-central1/getChatResponse?t=1',
        `${serverApi}getChatResponseDashboard?t=1`,
        JSON.stringify(postBody))
        .then(async (dataInit) => {
            // utils.printLog('tokenFetchPOST data');
            const data = await dataInit.json();
            console.dir(data);
            const ans = data['content'];
            if (ans != null) {
                const origAns = data['origAns'];
                if (prevMessages.length >= 2) {
                    prevMessages.shift();
                    console.dir(prevMessages);
                }
                prevMessages.push(origAns);
                return ans; //{'success': true};
            } else {
                return 'Currently chat is down';
            }
        }).catch((err) => {
            console.dir(err);
            return 'No response';
        });
    // return res['choices'] != null && res['choices'].length > 0
    //     ? res['choices'][0]['text']
    //     : 'No response';
}
